import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';
import { COMERCIAL_EMAIL } from '~/pages/NewOverview/components/UpgradeModuleModal/constants';
import { useFilterContext } from '~/pages/NewOverview/contexts/FilterContext';
import { ReactComponent as ConstructionUnitImage } from '../../../../../../../assets/img/overview/constructionUnit.svg';
import { AddConstructionButton, ConstructionAreaInfoContainer } from './styles';

export function ConstructionAreaInfo(): ReactElement {
  const [profile] = useState(getUserProfile);
  const { t } = useTranslation();
  const history = useHistory();
  const { clients } = useFilterContext();

  const emailLink = `mailto:${COMERCIAL_EMAIL}?subject=${t('areaConstruidaNaoInformada').replace(' ', '%20')}`;

  const showAddBuiltData = !!profile.manageAllClients;

  function onClickAddInfo(): void {
    if (clients.length === 1) {
      history.push(`painel/clientes/editar-cliente/${clients[0]}`);
    } else {
      history.push('painel/clientes/listagem');
    }
  }

  return (
    <>
      <ConstructionAreaInfoContainer data-testId="construction-area-card">
        <div>
          <ConstructionUnitImage />
          <h4>{t('areaConstruidaNaoInformada')}</h4>
          <span>{t('adicioneInformacoesAcompanharEficienciaEnergetica')}</span>
        </div>
      </ConstructionAreaInfoContainer>
      {showAddBuiltData ? (
        <AddConstructionButton
          type="button"
          variant="primary-ghost"
          onClick={onClickAddInfo}
        >
          {t('adicionarDadosAreaConstruida')}
        </AddConstructionButton>

      ) : (
        <a
          href={emailLink}
          target="_blank"
          data-testId="email-built-area-link"
          rel="noreferrer"
        >
          <AddConstructionButton type="button" variant="primary-ghost">
            {t('contatarSuporte')}
          </AddConstructionButton>

        </a>
      )}
    </>
  );
}
